export type PipelineCanvasLayoutDirection = 'TB' | 'LR';

export interface PipelineCanvasLayout {
  direction: PipelineCanvasLayoutDirection;
  node_positions: Record<string, { x: number; y: number }>;
}

/** Parse workspace_meta.canvas_layout with tolerant validation. */
export function parsePipelineCanvasLayout(raw: unknown): PipelineCanvasLayout | undefined {
  if (!raw || typeof raw !== 'object') return undefined;
  const obj = raw as Record<string, unknown>;
  const direction =
    obj.direction === 'LR' ? 'LR' : obj.direction === 'TB' ? 'TB' : undefined;
  if (!direction) return undefined;

  const node_positions: Record<string, { x: number; y: number }> = {};
  const positions = obj.node_positions;
  if (positions && typeof positions === 'object') {
    for (const [id, pos] of Object.entries(positions as Record<string, unknown>)) {
      if (!pos || typeof pos !== 'object') continue;
      const p = pos as Record<string, unknown>;
      if (typeof p.x === 'number' && typeof p.y === 'number') {
        node_positions[id] = { x: p.x, y: p.y };
      }
    }
  }

  return { direction, node_positions };
}
